import { styled } from '@material-ui/core/styles';

import { COLORS } from 'theme/constants';

export const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '134px',
});

export const ToggleSwitchContainer = styled('label')({
  display: 'inline-block',
  position: 'relative',
  width: '56px',
  height: '32px',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const ToggleSwitchInput = styled('input')({
  opacity: 0,
  width: 0,
  height: 0,
});

export const Switch = styled('span')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: theme.palette.sidebar.switchBackground,
  borderRadius: '34px',
  transition: 'all 0.2s',
}));

interface HandleProps {
  checked: boolean;
}

export const Handle = styled('span')(({ checked }: HandleProps) => ({
  display: 'block',
  content: '',
  position: 'absolute',
  width: checked ? '8px' : '16px',
  height: '16px',
  backgroundColor: '#fff',
  borderRadius: checked ? '0 8px 8px 0' : '50%',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.4)',
  left: checked ? '40px' : '6px',
  top: '8px',
  transition: 'all 0.2s',
}));

export const Label = styled('span')(({ theme }) => ({
  ...theme.typography.linkNav,
  color: COLORS.cozmosPurple2,
}));
